import React, { useState } from 'react';
import './Header.css';
import { ReactComponent as NotificationIcon } from '../../assets/notification-icon.svg';
import { ReactComponent as LanguageIcon } from '../../assets/language-icon.svg';
import { ReactComponent as Logo } from '../../assets/university-logo.svg';
import ThemeProvider from '../ThemeSwitcher/ThemeSwitcher';

function Header() {
    const [isAnimating, setIsAnimating] = useState(false);

    const handleNotificationClick = () => {
        setIsAnimating(true);
        setTimeout(() => setIsAnimating(false), 500);
    };
    return (
        <header className="w-full bg-white flex justify-end items-center px-14">
            <ThemeProvider />
            <button
                className={`w-8 h-8 mr-6 svg-icon ${isAnimating ? 'rotate-animation' : ''}`}
                onClick={handleNotificationClick}
            >
                <NotificationIcon />
            </button>
            <button
                className="custom-width w-24 h-10 mr-10 flex items-center justify-center border-2 border-gray-300 rounded-full svg-icon">
                <LanguageIcon className="mr-2" />
                <span>EN</span>
            </button>
            <Logo />
        </header>
    );
}

export default Header;
